module.exports = __webpack_public_path__ + "static/media/search.60647d2b.png";